<template>
  <!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
  <div class="tour-popup">
    <div id="modal_dashboard" class="modal left modal-dashbrd" role="dialog">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-header">
              <img
                src="/static/images/icons/popup_close.svg"
                class="close-btn"
                data-dismiss="modal"
                @click="closePopup"
                alt="close-icon"
              />
              <div class="dashboard-heading">
                <span v-if="currentTour.image">
                  <img :src="currentTour.image" alt="tour-icon" class="tour-icon" />
                </span>
                {{ currentTour.type }}
              </div>
              <img
                src="https://ramsdevstorage.blob.core.windows.net/customererrorpage/Header_swoop.png"
                class="header-swoop"
                alt="header-icon"
              />
            </div>
            <div>
              <p class="dashbrd-txt tour-title-text" v-html="currentTour.title"></p>
            </div>
            <div class="list-item pr-15" v-html="currentTour.content"></div>
            <div class="btn-next-div">
              <!-- <router-link :to="currentTour.url" v-if="currentTour.url != undefined"> -->
              <div
                class="modal-arrow"
                :style="[
                  {
                    top: `${currentTour.key == 0 ? 10 : currentTour.clickValue}px`,
                    'border-color': `${
                      currentTour.key > 3
                        ? (roleId == 3 || roleId === 6) && currentTour.key == 4
                          ? ''
                          : 'transparent #fff transparent transparent'
                        : ''
                    }`
                  },
                  { top: clickValue }
                ]"
              ></div>
              <button
                type="button"
                class="btn custom-btn mr-16 emergo-white-button"
                @click="previousTour()"
              >
                Back
              </button>
              <button
                type="button"
                class="btn custom-btn emergo-green-button"
                @click="playNextTour()"
              >
                Next
              </button>
              <!-- </router-link> -->
            </div>
            <div class="row">
              <span
                v-for="index in tourObjectLength"
                :key="index"
                v-bind:class="tourIndex === index - 1 ? 'active-round-button' : 'round-button'"
              ></span>
              <span class="round-button"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '../../utils/event-bus';

export default {
  data() {
    return {};
  },
  props: [
    'roleId',
    'displayRep',
    'currentTour',
    'playNextTour',
    'previousTour',
    'tourObjectLength',
    'tourIndex'
  ],
  methods: {
    closePopup() {
      EventBus.$emit('tourEnd');
    }
  },
  computed: {
    clickValue() {
      let val = this.currentTour.clickValue;
      if (this.roleId !== 6 && this.roleId !== 4 && this.currentTour.key > 9) {
        val += 45;
      }
      if ((this.roleId === 3 || this.roleId === 6) && this.currentTour.key > 2) {
        if (this.roleId === 6 && this.currentTour.key > 11) {
          val -= 90;
        } else {
          val -= 45;
        }
      }
      return `${val}px`;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-dashbrd {
  .modal-body {
    height: calc(100vh - 80px);
    padding: 0px !important;
    max-height: unset !important;
    scrollbar-width: thin;
  }
}
.description-txt {
  padding: 5px 15px 15px 15px;
}
.btn-next-div {
  margin-top: 45px;
  margin-bottom: 30px;
}
.mr-16 {
  margin-right: 16px;
}
.custom-btn {
  width: 133px;
  margin-top: 8px;
}
.dashboard-heading {
  margin: 70px auto;
}
.tour-title-text {
  color: #00518a;
  font-size: $font-24;
}
.modal {
  &.left {
    &.in {
      .modal-dialog {
        left: 230px;
      }
    }
  }
}
.list-item {
  display: list-item;
  ::v-deep sup {
    top: -0.1em;
    font-size: 100%;
  }
  ::v-deep ul li {
    margin: 20px 0;
    font-size: 15px;
    color: $primary;
    line-height: 19px;
  }
}
.tour-icon {
  width: 28px;
  margin-top: -4px;
}
.list-item {
  display: list-item;
}
::v-deep .list-item sup {
  top: -0.1em;
  font-size: 100%;
}
::v-deep .list-item ul li {
  margin: 20px 0;
  font-size: 15px;
  color: #0b3c61;
  line-height: 19px;
}
.row {
  width: 100%;
  text-align: center;
  margin: -15px 0 30px;
}
.round-button,
.active-round-button {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  float: none;
  border: 0.5px solid $primary;
  margin: 0 4px;
}
.active-round-button {
  background: $primary;
}

@media screen and (max-width: 767px) {
  .modal-dashbrd {
    display: none !important;
  }
}
</style>
